const rawScenario = (
  process.env.REACT_APP_MOCK_SCENARIO ?? 'multi-user'
).toLowerCase();

export type MockScenario =
  | 'single-user'
  | 'multi-user'
  | 'empty-docs'
  | 'empty-boletos'
  | 'empty-finance';

const allowedScenarios: MockScenario[] = [
  'single-user',
  'multi-user',
  'empty-docs',
  'empty-boletos',
  'empty-finance',
];

export const mockScenario: MockScenario = allowedScenarios.includes(
  rawScenario as MockScenario,
)
  ? (rawScenario as MockScenario)
  : 'multi-user';
